import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import * as ep from '../api/endpoints';
import { useAuth, useMe } from '../app/auth';
import { ErrorBox, Field } from '../components/ui';
import { formatDateTime } from '../lib/dates';
import { InstallGuide } from '../components/InstallGuide';
import { PushToggle } from '../components/PushToggle';
import { isStandalone } from '../platform';

const APP_VERSION = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '0.1.0';

/** Hesabım / kurulum: şifre, oturumlar, çıkış, uygulama sürümü, cihazıma kur (PDF §02/§04). */
export function AccountScreen() {
  const me = useMe();
  const { signOut } = useAuth();
  const qc = useQueryClient();
  const sessions = useQuery({ queryKey: ['sessions'], queryFn: ep.sessions });
  const [pw, setPw] = useState({ current: '', next: '' });
  const change = useMutation({ mutationFn: () => ep.changePassword(pw.current, pw.next), onSuccess: () => setPw({ current: '', next: '' }) });
  const revoke = useMutation({ mutationFn: ep.revokeOtherSessions, onSuccess: () => qc.invalidateQueries({ queryKey: ['sessions'] }) });

  return (
    <div className="stack">
      <h1>Hesabım</h1>
      <div className="card">
        <div className="title">{me.user.full_name}</div>
        <div className="small muted">{me.user.username} · {me.user.email} · {me.role === 'admin' ? 'Yönetici' : 'Kullanıcı'} · {me.organization.name}</div>
      </div>
      <PushToggle />
      <InstallCard />
      <form className="card stack" onSubmit={(e) => { e.preventDefault(); change.mutate(); }}>
        <h3 style={{ margin: 0 }}>Şifre değiştir</h3>
        <div className="form-grid two">
          <Field label="Mevcut şifre"><input type="password" autoComplete="current-password" value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} required /></Field>
          <Field label="Yeni şifre (en az 10)"><input type="password" autoComplete="new-password" minLength={10} value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} required /></Field>
        </div>
        <ErrorBox error={change.error} />
        {change.isSuccess && <div className="alert ok">Şifre değiştirildi; diğer cihazlardaki oturumlar kapatıldı.</div>}
        <button className="btn" disabled={change.isPending}>Kaydet</button>
      </form>
      <div className="card">
        <div className="row"><h3 style={{ margin: 0 }}>Oturumlar</h3><span className="spacer" /><button className="btn small" onClick={() => revoke.mutate()}>Diğer oturumları kapat</button></div>
        <ul className="list">
          {sessions.data?.map((s) => (
            <li key={s.id}><div className="item"><div style={{ flex: 1 }}>{s.device_label ?? 'Tarayıcı / uygulama'}{s.current && <span className="badge ok" style={{ marginLeft: 6 }}>Bu cihaz</span>}<div className="small muted">Son kullanım {formatDateTime(s.last_used_at)}</div></div></div></li>
          ))}
        </ul>
      </div>
      <div className="row">
        <span className="small muted">aksanenerji sürüm {APP_VERSION} · {isStandalone() ? 'kurulu uygulama' : 'tarayıcı'}</span>
        <span className="spacer" />
        <button className="btn danger" onClick={() => void signOut()}>Çıkış yap</button>
      </div>
    </div>
  );
}

/** Cihaza göre kurulum: tek uygulama aksanenerji (PWA). */
function InstallCard() {
  return (
    <div className="card stack">
      <h3 style={{ margin: 0 }}>Cihazıma kur</h3>
      <InstallGuide />
      <p className="small muted">Diğer cihazlar için: <Link to="/kur">tüm kurulum yönergeleri</Link></p>
    </div>
  );
}
